import { Controller } from "@hotwired/stimulus";

// Narrows rows already on the page as you type (walk/ORG.md screen 2).
// A row carries data-text (what it matches) and data-id (a card and its table
// row are one person); no round trip.
const fold = (s) => s.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase();

export default class extends Controller {
  static targets = ["input", "row", "list", "count", "none"];
  static values = { template: String };

  run() {
    const q = fold(this.inputTarget.value.trim());
    const all = new Set();
    const hit = new Set();
    this.rowTargets.forEach((row) => {
      const ok = fold(row.dataset.text).includes(q);
      row.hidden = !ok;
      all.add(row.dataset.id);
      if (ok) hit.add(row.dataset.id);
    });
    this.countTarget.textContent = this.templateValue
      .replace("{n}", hit.size)
      .replace("{total}", all.size);
    this.noneTarget.hidden = hit.size > 0;
    this.listTargets.forEach((el) => (el.hidden = hit.size === 0));
  }
}
